import * as THREE from 'three';

class Slice {
	constructor(i, spline) {
		this.createShape();

		const up = new THREE.Vector3(0, 0, 1);
		const axis = new THREE.Vector3();

		const point = spline.getPoint(i / 150);
		this.mesh.position.set(point.x, point.y, point.z);

		// get the tangent to the curve
		const tangent = spline.getTangent(i / 150).normalize();

		// calculate the axis to rotate around
		axis.crossVectors(up, tangent).normalize();

		// calculate the angle between the up vector and the tangent
		const radians = Math.acos(up.dot(tangent));

		// set the quaternion
		this.mesh.quaternion.setFromAxisAngle(axis, radians);
	}

	createShape() {
		const thickness = 2;
		const width = 20;

		this.shape = new THREE.Shape([
			new THREE.Vector2(-width * 0.9, thickness),
			new THREE.Vector2(-width, 0),
			new THREE.Vector2(-width * 0.9, -thickness),
			new THREE.Vector2(width * 0.9, -thickness),
			new THREE.Vector2(width, 0),
			new THREE.Vector2(width * 0.9, thickness),
		]);

		this.geometry = new THREE.ShapeGeometry(this.shape);
		const material = new THREE.MeshBasicMaterial({ color: 0x00ff00, wireframe: true });
		this.mesh = new THREE.Mesh(this.geometry, material);
	}

	calculate = () => {
		this.mesh.updateMatrixWorld();
		this.vertices = this.geometry.vertices.map(v => this.mesh.localToWorld(v.clone()));

		this.updateShape(50);

		this.mesh.updateMatrixWorld();
		this.cacheVerticesMaxWidth = this.geometry.vertices.map(v => this.mesh.localToWorld(v.clone()));

		this.cacheDifference = [];

		this.vertices.forEach((min, i) => {
			const max = this.cacheVerticesMaxWidth[i];

			const v = new THREE.Vector3(max.x - min.x, max.y - min.y, max.z - min.z);
			this.cacheDifference.push(v);
		});

		this.mesh.parent.remove(this.mesh);
	};

	updateShape = width => {
		const { vertices } = this.geometry;
		const { geometry } = this;

		const thickness = 5;

		vertices[0].set(-width * 0.9, thickness, 0);
		vertices[1].set(-width, 0, 0);
		vertices[2].set(-width * 0.9, -thickness, 0);
		vertices[3].set(width * 0.9, -thickness, 0);
		vertices[4].set(width, 0, 0);
		vertices[5].set(width * 0.9, thickness, 0);

		geometry.verticesNeedUpdate = true;
		geometry.elementsNeedUpdate = true;
		geometry.morphTargetsNeedUpdate = true;
		geometry.uvsNeedUpdate = true;
		geometry.normalsNeedUpdate = true;
		geometry.colorsNeedUpdate = true;
		geometry.tangentsNeedUpdate = true;
	};
}

export default Slice;



// WEBPACK FOOTER //
// ./src/threejs/sculpture/Slice.js